import compassLight from '../../assets/compass.svg';
import compassDark from '../../assets/compass-dark.svg';

interface CompassLogoProps {
  className?: string;
  size?: number;
}

/**
 * CompassLogo component that displays the appropriate compass SVG
 * based on the current color scheme (light/dark mode)
 */
export const CompassLogo = ({
  className = '',
  size = 40,
}: CompassLogoProps) => {
  return (
    <>
      {/* Light mode compass */}
      <img
        src={compassLight}
        alt="Compass"
        className={`block dark:hidden ${className}`}
        style={{ width: size, height: size }}
      />
      {/* Dark mode compass */}
      <img
        src={compassDark}
        alt="Compass"
        className={`hidden dark:block ${className}`}
        style={{ width: size, height: size }}
      />
    </>
  );
};
